$(document).ready(function(){
  // Initialize the slider
    var $slider = $('.slider-grid:not(.non-slider)');
    var slideCount = $slider.children().length; 
    var isMobile = $(window).width() < 768;

    function initalizeSlider() {
      
      if (slideCount > 3 || isMobile) {
          $slider.slick({
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              autoplay: true,
              autoplaySpeed: 3000,
              dots: false,
              arrows: false,
              responsive: [
                  {
                      breakpoint: 1024,
                      settings: {
                          slidesToShow: 2,
                          slidesToScroll: 1
                      }
                  },
                  {
                      breakpoint: 768,
                      settings: {
                          slidesToShow: 2,
                          slidesToScroll: 1
                      }
                  }
              ]
          });
      }

    }

  // Adjust heights
  function setEqualHeight() {
    var maxHeight = 0;

    // Reset heights
    $('.slider-grid .slick-slide').css('height', 'auto');

    // Calculate max height
    $('.slider-grid .slick-slide').each(function() {
      var thisHeight = $(this).outerHeight();
      if (thisHeight > maxHeight) {
        maxHeight = thisHeight;
      }
    });

    // Apply max height to all slides
    $('.slider-grid .slick-slide').css('height', maxHeight + 'px');
  }

  // Run on document ready
  initalizeSlider();
  setEqualHeight();

  // Run on window resize to adapt to responsive settings
  $(window).on('resize', function() {
    setEqualHeight();
    initalizeSlider();
  });
});
